import * as THREE from "three";
import { textFont } from "./assets/materials";
import { MathUtils } from "three";
var degToRad = MathUtils.degToRad;
export class SizeHelper {
    constructor(scene) {
        this.createSizeHelper(scene);
    }
    createSizeHelper(scene) {
        const sides = scene.dimensions;
        const widthHelperPos = new THREE.Vector3().copy(sides.close.position);
        const projectionHelperPos = new THREE.Vector3().copy(sides.left.position);
        const projectionHelperTextPos = new THREE.Vector3(sides.left.position.x, sides.left.position.x, sides.left.position.z);
        const widthHelperTextPos = new THREE.Vector3().copy(sides.close.position);
        projectionHelperPos.y = 15;
        widthHelperPos.y = 15;
        projectionHelperTextPos.y = 15;
        widthHelperTextPos.y = 15;
        if (scene.formData.measuredModel.rotated) {
            widthHelperPos.z += 30;
            projectionHelperPos.x -= 30;
            widthHelperTextPos.z += 90;
            projectionHelperTextPos.x -= 90;
        }
        else {
            widthHelperPos.x += 30;
            projectionHelperPos.z += 30;
            widthHelperTextPos.x += 90;
            projectionHelperTextPos.z += 90;
        }
        const purple = scene.formData.measuredModel.rotated ? new THREE.Color(0xFF5733) : new THREE.Color(0x696DEA);
        const orange = scene.formData.measuredModel.rotated ? new THREE.Color(0x696DEA) : new THREE.Color(0xFF5733);
        let projectionHelper = new THREE.Mesh(new THREE.BoxGeometry(sides.left.length, 5, 5), new THREE.MeshBasicMaterial({
            color: purple, transparent: true,
            opacity: 0.7,
        }));
        let widthHelper = new THREE.Mesh(new THREE.BoxGeometry(sides.close.length, 5, 5), new THREE.MeshBasicMaterial({
            color: orange, transparent: true,
            opacity: 0.7,
        }));
        projectionHelper.rotateY(degToRad(sides.left.rotationY));
        widthHelper.rotateY(degToRad(sides.close.rotationY));
        widthHelper.position.copy(widthHelperPos);
        projectionHelper.position.copy(projectionHelperPos);
        const projectionHelperTextShape = textFont.generateShapes(scene.formData.projectionValue.toString() + " cm", 50);
        const projectionHelperTextGeometry = new THREE.ShapeGeometry(projectionHelperTextShape);
        projectionHelperTextGeometry.center();
        const projectionHelperText = new THREE.Mesh(projectionHelperTextGeometry, projectionHelper.material);
        projectionHelperText.position.copy(projectionHelperTextPos);
        projectionHelperText.rotation.x = degToRad(-90);
        if (scene.formData.measuredModel.rotated === true) {
            projectionHelperText.rotation.z = degToRad(-90);
        }
        const widthHelperTextShape = textFont.generateShapes(scene.formData.widthValue.toString() + " cm", 50);
        const widthHelperTextGeometry = new THREE.ShapeGeometry(widthHelperTextShape);
        widthHelperTextGeometry.center();
        const widthHelperText = new THREE.Mesh(widthHelperTextGeometry, widthHelper.material);
        widthHelperText.position.copy(widthHelperTextPos);
        widthHelperText.rotation.x = degToRad(-90);
        if (scene.formData.measuredModel.rotated !== true) {
            widthHelperText.rotation.z = degToRad(90);
        }
        if (scene.formData.measuredModel.rotated) {
            projectionHelper.material.color = orange;
            widthHelper.material.color = purple;
        }
        scene.threeScene.add(projectionHelper, widthHelper, widthHelperText, projectionHelperText);
    }
}
